<template>
	<v-autocomplete
		v-model:search="tagInputSearch"
		:class="['tag-input-autocomplete', { readonly: readOnly }]"
		density="compact"
		:disabled="
			isGraphAxisValueTag ||
			disabled ||
			[Mode.BLANK_TABLE_CELL, Mode.BRANCH_EDIT, Mode.BRANCH_SELECT].includes(
				mode,
			)
		"
		hide-details="auto"
		item-title="name"
		item-value="uuid"
		:items="tags"
		:menu-props="{
			offsetY: true,
			closeOnClick: true,
			activator: 'parent',
			contentProps: {
				onKeydown: (event) => {
					event.stopPropagation();
				},
			},
			disabled: readOnly,
		}"
		:model-value="modelValue.tag"
		no-data-text="No tags available"
		persistent-placeholder
		:placeholder="mode === Mode.BRANCH_SELECT ? 'Study branch' : 'Tag'"
		:readonly="readOnly"
		return-object
		@keydown="tagInputKeydown($event, modelValue)"
		@update:model-value="updateTagValue"
	>
		<template #label>
			<span class="d-inline-flex align-center label-with-info">
				{{ getTagInputLabel() }}
				<v-tooltip v-if="isGraphAxisValueTag" location="bottom">
					<template #activator="{ props }">
						<v-icon
							v-bind="props"
							size="x-small"
							class="ml-1 info-icon-in-label"
						>
							mdi-information
						</v-icon>
					</template>
					<span>
						This tag is from a graph axis value and can only be changed in the
						graph calibration settings; the value itself can still be updated.
					</span>
				</v-tooltip>
			</span>
		</template>
	</v-autocomplete>
</template>

<script>
import _ from "lodash";

import { Mode } from "./VMetadataConstants.js";

export default {
	name: "VMetadataTagSelect",

	inject: ["showKeyPicker"],

	props: {
		disabled: { type: Boolean, default: false },
		isGraphAxisValueTag: { type: Boolean, default: false },
		limitTagGroups: { type: Array, default: () => [] },
		mode: { type: String, default: Mode.STANDARD },
		modelValue: { type: Object, default: null },
		readOnly: { type: Boolean, default: false },
		tab: { type: Object, default: null },
		tags: { type: Array, default: () => [] },
	},

	emits: ["update:modelValue"],

	setup() {},

	data() {
		return {
			tagInputSearch: "",
			Mode,
		};
	},
	computed: {},

	methods: {
		getTagInputLabel() {
			if (this.tab) {
				return this.tab.name;
			}

			if (!_.isEmpty(this.limitTagGroups)) {
				return this.limitTagGroups.map((tagGroup) => tagGroup.name).join(", ");
			}

			return "";
		},
		tagInputKeydown(event, metadatum) {
			switch (event.key) {
				case "ArrowLeft":
				case "ArrowRight":
				case "ArrowUp":
				case "ArrowDown":
					event.stopPropagation();
					break;
				case "Backspace":
					if (!_.isEmpty(metadatum.tag)) {
						if (this.showKeyPicker(metadatum.tag)) {
							metadatum.value = null;
						}
						metadatum.tag = null;
						this.$emit("update:modelValue", {
							...this.modelValue,
							value: metadatum.value,
							tag: metadatum.tag,
						});
						this.tagInputSearch = "";
					}
					break;
			}
		},
		updateTagValue(value) {
			this.$emit("update:modelValue", {
				...this.modelValue,
				tag: value,
			});
		},
	},
};
</script>

<style lang="scss">
.tag-input-autocomplete .v-field-label {
	top: 1px !important;
	font-size: 10px;
}
.tag-input-autocomplete.readonly .v-overlay {
	display: none !important;
}
.tag-input-autocomplete.readonly .v-field__append-inner {
	display: none;
}
.tag-input-autocomplete.v-input--disabled,
.tag-input-autocomplete.v-input--readonly {
	.v-field__input,
	.v-field__field,
	.v-autocomplete__selection-text {
		opacity: 1;
	}
	input,
	.v-autocomplete__selection-text {
		color: rgba(0, 0, 0, 1) !important;
	}
}
.label-with-info {
	pointer-events: none;
}
.info-icon-in-label {
	pointer-events: all !important;
	cursor: help !important;
}
</style>
